import { useTranslation } from 'react-i18next';

import { StatusChip } from '@/shared/ui/StatusChip';

import { groupRowChipSx } from './GeneratikGroupingCell.styles';
import { PaginationLabel, PaginationPill } from './GeneratikTable.styles';
import { groupTotalLabelSx, groupTotalPillSx } from './GeneratikTableGroupTotalPill.styles';

interface GeneratikTableGroupTotalPillProps {
  label: string;
  price: number;
  currency?: string;
  testId?: string;
  chipBgColor?: string;
  asChip?: boolean;
  priceForPeriod?: boolean;
}

const DEFAULT_CHIP_BG = '#8F8EA3';

const formatGroupPrice = (price: number): string =>
  price.toLocaleString('ro-RO', { minimumFractionDigits: 0, maximumFractionDigits: 2 });

const GeneratikTableGroupTotalPill = ({
  label,
  price,
  currency = '€',
  testId = 'group-total-price',
  chipBgColor = DEFAULT_CHIP_BG,
  asChip = false,
  priceForPeriod = false,
}: GeneratikTableGroupTotalPillProps) => {
  const { t } = useTranslation();
  const text = `${label}: ${formatGroupPrice(price)} ${currency}/${t(
    priceForPeriod ? 'period_suffix' : 'month',
  )}`;

  if (asChip) {
    return <StatusChip label={text} bg={chipBgColor} sx={groupRowChipSx} testId={testId} />;
  }

  return (
    <PaginationPill sx={groupTotalPillSx} data-testid={testId}>
      <PaginationLabel sx={groupTotalLabelSx}>{text}</PaginationLabel>
    </PaginationPill>
  );
};

export default GeneratikTableGroupTotalPill;
